import styled from "styled-components";
export const NeedHelpFooter = styled.div `
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0 14px;
  margin-top: auto;
  border-top: 1px solid #e4e7ef;
  background: #f4f6fb;
`;
export const NeedHelpExpandedText = styled.span `
  display: none;
  color: #5b6478;
  font-weight: 450;
  white-space: normal;
`;
export const NeedHelpChip = styled.button `
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
  max-width: 100%;
  padding: 10px 18px;
  border: 1px solid #d5dae6;
  border-radius: 999px;
  background: #ffffff;
  color: #5b6478;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  cursor: pointer;
  transition:
    padding 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    background 0.18s ease;
  box-shadow: none;

  &:hover,
  &:focus-visible,
  &:focus-within,
  &.is-expanded {
    padding: 12px 20px;
    border-color: #c0c7d8;
    background: #fafbfe;
    box-shadow: 0 2px 8px rgba(24, 29, 39, 0.06);
    outline: none;

    ${NeedHelpExpandedText} {
      display: inline;
    }
  }
`;
export const NeedHelpLabel = styled.span `
  white-space: nowrap;
  color: #434b5c;
  font-weight: 600;
`;
export const NeedHelpPhoneLink = styled.a `
  color: #434b5c;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover,
  &:focus {
    color: #181d27;
  }
`;
